<div class="dtf-accountdetails">
  <mat-dialog-content>
    @if(this.addressdialog ==='one'){
      @if(this.language ==='en-US' || this.language ==='en-CA'){
        <h2><b>Contract/Lease Agreement</b></h2>
        <p>You have successfully submitted this request. Please allow 1 to 2 business days for this request to process depending on current volume.</p>
    }
     @if(this.language ==='fr-CA'){
        <h2><b>Copie du contrat</b></h2>
        <p>Succès votre copie de la demande de contrat a été soumise</p>
      }
    }

    @if(this.addressdialog ==='two'){
      @if(this.language ==='en-US'){
        <h2><b>State-To-State Transfer</b></h2>
        <p>Success your State-To-State Transfer has been submitted.</p>
    }
    @if(this.language ==='en-CA'){
      <h2><b>Lien release request</b></h2>
      <p>Success your lien request has been submitted</p>
  }
     @if(this.language ==='fr-CA'){
      <h2><b>Demande de libération de privilège</b></h2>
      <p>Succès votre demande de privilège a été soumise</p>
      }
    }

    @if(this.addressdialog ==='error'){
      @if(this.language ==='en-US'){
        <h2><b>Error</b></h2>
      }
      @if(this.language ==='en-CA'){
        <h2><b>Error</b></h2>
      }
      @if(this.language ==='fr-CA'){
        <h2><b>Erreur</b></h2>
      }
      <p><b>{{errorMessage}}</b></p>
    }
  </mat-dialog-content>

  <mat-dialog-actions>
    @if(this.addressdialog ==='one' || this.addressdialog ==='two'){
      <button mat-button (click)="dashboardRedirect($event)" mat-dialog-close>Continue</button>
    }
    @if(this.addressdialog ==='error'){
      <button mat-button mat-dialog-close>Continue</button>
    }
  </mat-dialog-actions>
  
</div>